import Empty from '@/views/Empty';
import ShipmentIndex from '@/views/pages/shipment_md/Index';

import ShipmentList from '@/views/pages/shipment_md/shipments/List';
import ShipmentDetail from '@/views/pages/shipment_md/shipments/Detail';
import ShipmentDetailIndex from '@/views/pages/shipment_md/shipments/detail/Index';
import ShipmentOrders from '@/views/pages/shipment_md/shipments/detail/Orders';
import ShipmentCreateEdit from '@/views/pages/shipment_md/shipments/CreateEdit';
import AddShipmentOrder from '@/views/pages/shipment_md/shipments/detail/AddOrder';
import ShipmentCompletion from '@/views/pages/shipment_md/shipments/completion/Index';
import ShipmentTracking from '@/views/pages/shipment_md/shipments/tracking/Index';

import OrderList from '@/views/pages/shipment_md/orders/List';
import OrderDetail from '@/views/pages/shipment_md/orders/Detail';
import OrderDetailIndex from '@/views/pages/shipment_md/orders/detail/Index';
import OrderUnits from '@/views/pages/shipment_md/orders/detail/Units';
import OrderCreateEdit from '@/views/pages/shipment_md/orders/CreateEdit';
import OrderRouting from '@/views/pages/shipment_md/orders/OrderRouting';
import OrderSchedule from '@/views/pages/shipment_md/orders/OrderSchedule';
import OrderDelivery from '@/views/pages/shipment_md/orders/OrderDelivery';
import OrderStatus from '@/views/pages/shipment_md/orders/OrderStatus';
import AddOrderUnit from '@/views/pages/shipment_md/orders/detail/AddUnit';

import CustomerList from '@/views/pages/shipment_md/customers/List';
import CustomerDetail from '@/views/pages/shipment_md/customers/Detail';
import CustomerPreview from '@/views/pages/shipment_md/customers/detail/Preview';
import CustomerLocations from '@/views/pages/shipment_md/customers/detail/Locations';
import CustomerCreateEdit from '@/views/pages/shipment_md/customers/CreateEdit';

import LocationList from '@/views/pages/shipment_md/locations/List';
import LocationDetail from '@/views/pages/shipment_md/locations/Detail';
import LocationPreview from '@/views/pages/shipment_md/locations/detail/Preview';
import LocationCreateEdit from '@/views/pages/shipment_md/locations/CreateEdit';

import FindShipmentResult from '@/views/pages/shipment_md/find_shipment_result/Index';

export default {
  path: 'shipment_md',
  component: Empty,
  meta: {
  },
  children: [
    {
      path: '',
      name: 'Shipment',
      component: ShipmentIndex,
    },
    {
      path: 'shipments',
      component: Empty,
      // redirect: 'companies/',
      children: [
        {
          path: '',
          name: 'Shipments',
          component: ShipmentList,
          meta: {
            accessKey: 'SHIPMENT.SHIPMENT.READ',
          },
        },
        {
          path: 'create',
          name: 'Create Shipment',
          component: ShipmentCreateEdit,
        },
        {
          path: 'completion',
          name: 'Shipment Completion',
          component: ShipmentCompletion,
        },
        {
          path: 'tracking',
          name: 'Shipment Tracking',
          component: ShipmentTracking,
        },
        {
          path: ':shipmentId',
          component: ShipmentDetail,
          children: [
            {
              path: '',
              name: 'Shipment Detail',
              component: ShipmentDetailIndex,
            },
            {
              path: 'orders',
              name: 'Shipment Orders',
              component: ShipmentOrders,
            },
            {
              path: 'add_order',
              name: 'Add Shipment Order',
              component: AddShipmentOrder,
            },
          ],
        },
        {
          path: ':shipmentId/edit',
          name: 'Edit Shipment',
          component: ShipmentCreateEdit,
        },
      ],
    },
    {
      path: 'orders',
      component: Empty,
      children: [
        {
          path: 'create',
          name: 'Create Order',
          component: OrderCreateEdit,
        },
        {
          path: 'routing',
          name: 'Order Routing',
          component: OrderRouting,
        },
        {
          path: 'status',
          name: 'Order Status',
          component: OrderStatus,
        },
        {
          path: 'schedule',
          name: 'Order Schedule',
          component: OrderSchedule,
        },
        {
          path: 'delivery',
          name: 'Order Delivery',
          component: OrderDelivery,
        },
        {
          path: '',
          name: 'Orders',
          component: OrderList,
        },
        {
          path: ':orderId',
          component: OrderDetail,
          children: [
            {
              path: '',
              name: 'Order Detail',
              component: OrderDetailIndex,
            },
            {
              path: 'units',
              name: 'Order Units',
              component: OrderUnits,
            },
            {
              path: 'add_unit',
              name: 'Add Order',
              component: AddOrderUnit,
            },
          ],
        },
        {
          path: ':orderId/edit',
          name: 'Edit Order',
          component: OrderCreateEdit,
        },
      ],
    },
    {
      path: 'customers',
      component: Empty,
      children: [
        {
          path: '',
          name: 'Customers',
          component: CustomerList,
        },
        {
          path: 'create',
          name: 'Customer Create',
          component: CustomerCreateEdit,
        },
        {
          path: ':companyId',
          component: CustomerDetail,
          children: [
            {
              path: '',
              name: 'Customer Preview',
              component: CustomerPreview,
            },
            {
              path: 'locations',
              name: 'Customer Locations',
              component: CustomerLocations,
            },
          ],
        },
        {
          path: ':companyId/edit',
          name: 'Customer Edit',
          component: CustomerCreateEdit,
        },
      ],
    },
    {
      path: 'Locations',
      component: Empty,
      children: [
        {
          path: '',
          name: 'Location',
          component: LocationList,
        },
        {
          path: 'create',
          name: 'Location Create',
          component: LocationCreateEdit,
        },
        {
          path: ':locationId',
          component: LocationDetail,
          children: [
            {
              path: '',
              name: 'Location Preview',
              component: LocationPreview,
            },
          ],
        },
        {
          path: ':locationId/edit',
          name: 'Location Edit',
          component: LocationCreateEdit,
        },
      ],
    },
    {
      path: 'find_shipment_result',
      name: 'Shipment Result',
      component: FindShipmentResult,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/shipment_md.js